@if (playerRestrictions.length > 0) {
  @for (restriction of playerRestrictions; track restriction) {
    <div
      class="player-restriction-marker"
      [style.left.%]="restriction.relativePosLeft"
      [style.width.%]="restriction.relativeWidth"
    ></div>
  }
}
